import { Paper, Stack, Typography } from '@mui/material';
import React from 'react';

import StudyReportSectionNumberBadge from './StudyReportSectionNumberBadge';

interface Props {
  sectionNumber: React.ReactNode;
  title: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

const StudyReportSectionSurface: React.FC<Props> = ({ sectionNumber, title, actions, children }) => (
  <Paper variant="outlined" sx={{ p: 3, minWidth: 0 }}>
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ minWidth: 0, flex: 1 }}>
          <StudyReportSectionNumberBadge value={sectionNumber} />
          <Typography variant="h6" fontWeight={600} sx={{ flex: 1, minWidth: 0 }}>
            {title}
          </Typography>
        </Stack>

        {actions ? (
          <Stack direction="row" spacing={0.5}>
            {actions}
          </Stack>
        ) : null}
      </Stack>

      {children}
    </Stack>
  </Paper>
);

export default StudyReportSectionSurface;
